import React from 'react';
import Notification from './Notification';
import boomiLogo from '../../../img/AtomSphere-Logo.svg';
import HeaderNav from './HeaderNav';
import translations from '../../translations';
import { signOut } from '../../actions/reduxActions/currentUser';
import User from './User';

import { connect } from 'react-redux';
import { navigate } from '@reach/router';

import '../../../css/transitions.less';
import '../../../css/tab-header-dropdown.less';
import '../../../css/logo.less';

/**
 * @description A component that renders the Tooling header
 */
const Header = ({ currentUser, signOutAction }) => {
    const onLogoutClick = () => {
        signOutAction();
        navigate('/');
    };

    return (
        <div className="tab-header">
            <div className="logo">
                <img src={boomiLogo} alt="Boomi AtomSphere" />
            </div>
            <HeaderNav />
            <ul className="tab-header-admin header-admin-right">
                {
                    currentUser.isSso ? 
                        // SSO users shouldn't be able to see the user settings button for now
                        // because it adds confusion and doesn't function fully as expected
                        null : 
                        <User tenantId={currentUser.tenantId} />
                }
                <Notification />
                {
                    currentUser.isSso ? 
                        // SSO users shouldn't be able to see the logout button for now
                        // because it adds confusion and doesn't function fully as expected
                        null :
                        (
                            <li>
                                <div className="logout">
                                    <button className="logout-btn" onClick={onLogoutClick}>
                                        {translations['logout text']}
                                    </button>
                                </div>
                            </li>
                        )
                }
            </ul>
        </div>
    );
};


const mapStateToProps = ({ currentUser }) => ({ currentUser });
const mapDispatchToProps = { signOutAction: signOut };

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Header);
